(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bestsellers-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bestsellers-product-slider')) {
    class BestsellersProductSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-slider-track]');
        this.slides = Array.from(this.querySelectorAll('[data-slider-slide]'));
        this.previousButton = this.querySelector('[data-slider-prev]');
        this.nextButton = this.querySelector('[data-slider-next]');
        this.dots = Array.from(this.querySelectorAll('[data-slider-dot]'));

        if (!this.track || this.slides.length < 2) return;

        this.currentIndex = 0;
        this.onScroll = this.onScroll.bind(this);
        this.previousButton?.addEventListener('click', () => this.goTo(this.currentIndex - 1));
        this.nextButton?.addEventListener('click', () => this.goTo(this.currentIndex + 1));
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.goTo(index)));
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.updateControls();
      }

      disconnectedCallback() {
        this.track?.removeEventListener('scroll', this.onScroll);
        window.clearTimeout(this.scrollTimer);
      }

      onScroll() {
        window.clearTimeout(this.scrollTimer);
        this.scrollTimer = window.setTimeout(() => {
          const firstSlide = this.slides[0];
          const step = firstSlide.offsetWidth + parseFloat(getComputedStyle(this.track).columnGap || 0);
          this.currentIndex = Math.max(0, Math.min(this.slides.length - 1, Math.round(this.track.scrollLeft / step)));
          this.updateControls();
        }, 50);
      }

      goTo(index) {
        const nextIndex = Math.max(0, Math.min(this.slides.length - 1, index));
        this.currentIndex = nextIndex;
        this.slides[nextIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        this.updateControls();
      }

      updateControls() {
        if (this.previousButton) this.previousButton.disabled = this.currentIndex === 0;
        if (this.nextButton) this.nextButton.disabled = this.currentIndex === this.slides.length - 1;
        this.dots.forEach((dot, index) => {
          const isActive = index === this.currentIndex;
          dot.classList.toggle('is-active', isActive);
          if (isActive) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }
    }

    customElements.define('bestsellers-product-slider', BestsellersProductSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-reviews-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bp-review-slider')) {
    class BpReviewSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-review-track]');
        this.slides = Array.from(this.querySelectorAll('[data-review-slide]'));
        this.previousButton = this.querySelector('[data-review-prev]');
        this.nextButton = this.querySelector('[data-review-next]');
        this.dots = Array.from(this.querySelectorAll('[data-review-dot]'));

        if (!this.track || this.slides.length < 2) return;

        this.currentIndex = 0;
        this.onScroll = this.onScroll.bind(this);
        this.previousButton?.addEventListener('click', () => this.goTo(this.currentIndex - 1));
        this.nextButton?.addEventListener('click', () => this.goTo(this.currentIndex + 1));
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.goTo(index)));
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.updateControls();
      }

      disconnectedCallback() {
        this.track?.removeEventListener('scroll', this.onScroll);
        window.clearTimeout(this.scrollTimer);
      }

      onScroll() {
        window.clearTimeout(this.scrollTimer);
        this.scrollTimer = window.setTimeout(() => {
          const firstSlide = this.slides[0];
          const step = firstSlide.offsetWidth + parseFloat(getComputedStyle(this.track).columnGap || 0);
          this.currentIndex = Math.max(0, Math.min(this.slides.length - 1, Math.round(this.track.scrollLeft / step)));
          this.updateControls();
        }, 50);
      }

      goTo(index) {
        const nextIndex = Math.max(0, Math.min(this.slides.length - 1, index));
        this.currentIndex = nextIndex;
        this.slides[nextIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        this.updateControls();
      }

      updateControls() {
        if (this.previousButton) this.previousButton.disabled = this.currentIndex === 0;
        if (this.nextButton) this.nextButton.disabled = this.currentIndex === this.slides.length - 1;
        this.dots.forEach((dot, index) => {
          const isActive = index === this.currentIndex;
          dot.classList.toggle('is-active', isActive);
          if (isActive) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }
    }

    customElements.define('bp-review-slider', BpReviewSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["type-collection-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('collection-card-slider')) {
    class CollectionCardSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-slider-track]');
        this.slides = Array.from(this.querySelectorAll('[data-slider-slide]'));
        this.previousButton = this.querySelector('[data-slider-prev]');
        this.nextButton = this.querySelector('[data-slider-next]');
        this.dots = Array.from(this.querySelectorAll('[data-slider-dot]'));

        if (!this.track || this.slides.length < 2) return;

        this.currentIndex = 0;
        this.onScroll = this.onScroll.bind(this);
        this.previousButton?.addEventListener('click', () => this.goTo(this.currentIndex - 1));
        this.nextButton?.addEventListener('click', () => this.goTo(this.currentIndex + 1));
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.goTo(index)));
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.updateControls();
      }

      disconnectedCallback() {
        this.track?.removeEventListener('scroll', this.onScroll);
        window.clearTimeout(this.scrollTimer);
      }

      onScroll() {
        window.clearTimeout(this.scrollTimer);
        this.scrollTimer = window.setTimeout(() => {
          const firstSlide = this.slides[0];
          const step = firstSlide.offsetWidth + parseFloat(getComputedStyle(this.track).columnGap || 0);
          this.currentIndex = Math.max(0, Math.min(this.slides.length - 1, Math.round(this.track.scrollLeft / step)));
          this.updateControls();
        }, 50);
      }

      goTo(index) {
        const nextIndex = Math.max(0, Math.min(this.slides.length - 1, index));
        this.currentIndex = nextIndex;
        this.slides[nextIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        this.updateControls();
      }

      updateControls() {
        if (this.previousButton) this.previousButton.disabled = this.currentIndex === 0;
        if (this.nextButton) this.nextButton.disabled = this.currentIndex === this.slides.length - 1;
        this.dots.forEach((dot, index) => {
          const isActive = index === this.currentIndex;
          dot.classList.toggle('is-active', isActive);
          if (isActive) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }
    }

    customElements.define('collection-card-slider', CollectionCardSlider);
  }

  } catch(e) { console.error(e); }
})();
})();
